// eslint-disable-next-line import/no-extraneous-dependencies
import { LogLevel } from '@azure/msal-browser'

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID,
    authority: process.env.REACT_APP_AUTHORITY,
    // redirectUri: process.env.REACT_APP_REDIRECT_URI,
    redirectUri: `${window.location.origin}/dashboard`,

    postLogoutRedirectUri: '/',
    // navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message)
            return
          case LogLevel.Info:
            console.info(message)
            // eslint-disable-next-line no-useless-return
            return

          default:
            // eslint-disable-next-line no-useless-return
            return
        }
      },
    },
  },
}
export const loginRequest = {
  scopes: ['user.read'],
}
